interface CategoryCardProps {
  name: string;
  url: string;
  icon: string;
  imageUrl: string;
  index: number;
}

export default function CategoryCard({ name, url, icon, imageUrl, index }: CategoryCardProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener nofollow"
      className="flex-shrink-0 w-[280px] md:w-[300px] group cursor-pointer"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200">
        <div className="relative h-52 md:h-56 overflow-hidden bg-background-100">
          <img
            src={imageUrl}
            alt={`Catégorie ${name}`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <div className="flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700">
                <i className={icon}></i>
              </span>
              <span className="text-sm font-semibold text-background-50 drop-shadow-sm">{name}</span>
            </div>
            <p className="text-xs text-background-50/80 mt-1 ml-8">Voir sur kaspreadsheet.com</p>
          </div>
        </div>
      </div>
    </a>
  );
}